(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/core/assets/javascripts/collections/invitees.js') >= 0) return;  svs.modules.push('/components/syndicate/core/assets/javascripts/collections/invitees.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.syndicate.core.collections.Invitees = Backbone.Collection.extend({
    model: svs.syndicate.core.models.Invitee
  });
})(Backbone, _, svs);


 })(window);